import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateTwoPDFSection, TemplateTwoPDFSectionWithSubsections } from "./common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeProject, ResumeAward } from "lib/redux/types";

export const Award = ({
  heading,
  awards,
  themeColor,
}: {
  heading: string;
  awards: ResumeAward[];
  themeColor: string;
}) => {
  return (
    <TemplateTwoPDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      {awards.map(({ award, issuer, descriptions }, idx) => (
        <View key={idx} wrap={false} style={{ ...styles.flexRow }}>
          <View style={{ width: "30%", marginTop: "2pt" }}></View> {/* Reduced from spacing["0.5"] (6pt) to 2pt */}
          <View style={{ width: "70%", marginTop: "2pt" }}> {/* Reduced from spacing["0.5"] (6pt) to 2pt */}
            <View
              style={{
                marginTop: spacing["0.5"],
              }}
            >
              <View
                style={{
                  ...styles.flexRow,
                  gap: spacing["2"],
                }}
              >
                <ResumePDFText bold={true}>{award}</ResumePDFText>
                <ResumePDFText bold={true}>{issuer}</ResumePDFText>
              </View>
            </View>
            <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
              <ResumePDFDescription items={descriptions} />
            </View>
          </View>
        </View>
      ))}
    </TemplateTwoPDFSectionWithSubsections>
  );
};
